// extracted by mini-css-extract-plugin
module.exports = {"table":"TimeBetweenEvents_table__2pRxv","tableHeader":"TimeBetweenEvents_tableHeader__1UJNa"};